<div class="kpi-column-body">
  <div class="kpi-column-body__title">{{ title }}</div>
  <div *ngFor="let kpi of kpis; trackBy: trackByFunction">
    <app-kpi-tile [kpi]="kpi" [isActionEnabled]="areKpiActionsEnabled" [hideDismountButton]="hideDismountButton"></app-kpi-tile>
  </div>
</div>
